import TextField from '@mui/material/TextField';
import styled from 'styled-components';

export const StyledTextField = styled(TextField)`
  & .MuiInput-underline.Mui-disabled:before {
    border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  }
  & .MuiInput-underline:after {
    border-bottom-color: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.turquoise.T300
        : props.theme.atlas.semantic.color.action.primary.default};
  }
  & .MuiInputLabel-root.Mui-focused {
    color: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.turquoise.T300
        : props.theme.atlas.semantic.color.action.primary.default};
  }
`;
